export const LAYOUT_TYPE = {
  layout1: 'layout1',
  layout2: 'layout2',
  layout3: 'layout3',
  layout4: 'layout4',
  layout5: 'layout5',
}

export const WIDGET_TYPE = {
  INSTAGRAM_POST: 'instagramPost',
  COLLECTION: 'collection',
  CATEGORY: 'category',
  CATEGORIES: 'categories',
  FEATURE: 'feature',
  FEATURED_COLLECTION: 'featuredCollection',
  FEATURED_REELS: 'featuredReels',
  TESTIMONIALS: 'testimonials',
  LOGO_SLIDER: 'logoSlider',
  BLOG: 'blog',
  ICON: 'icon',
  IMAGE: 'image',
  INSTAGRAM: 'instagram'
}

export const CONTAINER_TYPE = {
  GRID: 'grid',
  CAROUSEL: 'carousel'
}

export const ADDITIONAL_PAGES_TYPE = {
  ADDITIONAL_PAGE: 1,
  BLOGS: 2,
}
